import React, { useEffect } from "react";
import UPITxnAnalysisPage from "../../../UPITxnAnalysis";
import { getUPITxn } from "../../../../../api/UPITxn";
import { useDispatch, useSelector } from "react-redux";
import { setUPITxnAnalysisDetails, setUPITxnAnalysisError, setUPITxnAnalysisLoading } from "../../../../../store/reducers/slices/upiTxnAnalysis.slice";

const UPITxnAnalysisWrapper = () => {
    const dispatch = useDispatch();

    const upiTxnAnalysis = useSelector(({ upiTxnAnalysis }) => upiTxnAnalysis);
    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

    useEffect(() => {

        const fetchData = async () => {
            dispatch(setUPITxnAnalysisLoading(true));
            try {
                let aggregate = selectedAccountId !== 'all'? false : true;
                let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
                const response = await getUPITxn(account_id, aggregate);
                dispatch(setUPITxnAnalysisDetails(response));
                dispatch(setUPITxnAnalysisLoading(false));
            } catch (error) {
                console.log("ERROR", error);
                dispatch(setUPITxnAnalysisLoading(false));
                dispatch(setUPITxnAnalysisError(error.message));
            }
        }
        if (selectedAccountId) {
            fetchData();
        }
        // else {
        //     dispatch(setUPITxnAnalysisLoading(false));
        // }

    }, [selectedAccountId])
    return (
        <UPITxnAnalysisPage />
    );
};

export default UPITxnAnalysisWrapper;
